// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__CW92Y","spin":"Spinner_spin__jB/jC","outline":"Spinner_outline__gnLko"};